import React from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';

import { parseApiError } from 'modules/access-control/utils';

export const onError = (error: any) => {
  toast.error(<FormattedMessage id={parseApiError(error)} />, { duration: Infinity });
};
